(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4281],{

/***/ 65506:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[category]",
      function () {
        return __webpack_require__(55733);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Categories; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _components_Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30341);
/* harmony import */ var _components_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48300);





var defaultProps = {
    categories: [],
    active: null
};
var propTypes = {
    categories: prop_types__WEBPACK_IMPORTED_MODULE_3___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_3___default().object)),
    active: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};
function Categories(param) {
    var categories = param.categories, active = param.active;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative z-20 bg-gray-900 text-gray-100",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                className: "flex w-full items-center space-x-4 py-2 lg:py-3",
                children: categories.map(function(param) {
                    var id = param.id, slug = param.slug, name = param.name, uri = param.uri;
                    var isActive = active === slug;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        href: uri,
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("flex items-center font-medium transition duration-150 ease-in-out md:text-lg", isActive === true && "pointer-events-none text-green-500", isActive === false && "border-transparent text-gray-300 hover:text-white"),
                        children: name
                    }, id);
                })
            })
        })
    });
};
Categories.defaultProps = defaultProps;
Categories.propTypes = propTypes;


/***/ }),

/***/ 82283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Posts; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Container/index.js
var Container = __webpack_require__(30341);
// EXTERNAL MODULE: ./src/domain/Blog/Categories.js
var Categories = __webpack_require__(96829);
// EXTERNAL MODULE: ./src/components/Link/index.js + 2 modules
var Link = __webpack_require__(48300);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/domain/Blog/PostListing.js



function PostListing(param) {
    var uri = param.uri, title = param.title, excerpt = param.excerpt, featuredImage = param.featuredImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
        href: uri,
        className: "relative flex w-full transition duration-200 ease-in-out rounded-lg lg:rounded-xl xl:rounded-2xl",
        children: function(param) {
            var isHovering = param.isHovering;
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative z-10 flex flex-col w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full h-0 overflow-hidden bg-gray-100 bg-center bg-cover rounded-t-lg h-50 transition-cpu lg:rounded-t-xl xl:rounded-t-2xl",
                                style: {
                                    paddingTop: "calc((9% / 16) * 100)",
                                    transition: "clip-path 0.25s ease-in-out,-webkit-clip-path 0.25s ease-in-out",
                                    clipPath: isHovering ? "inset(0% 0% 0 0% round 12px 12px 0px 0px)" : "inset(8% 4% 0 4% round 12px 12px 12px 12px)",
                                    backgroundImage: "url('".concat(featuredImage === null || featuredImage === void 0 ? void 0 : (ref = featuredImage.node) === null || ref === void 0 ? void 0 : ref.sourceUrl, "')")
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col px-8 py-8 space-y-2 rounded-b-lg lg:space-y-4 lg:rounded-b-xl xl:rounded-b-2xl",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-lg font-medium",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "relative overflow-hidden lg:h-20 xl:h-28",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "font-normal prose",
                                                dangerouslySetInnerHTML: {
                                                    __html: excerpt
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute bottom-0 left-0 right-0 w-full h-10 bg-gradient-to-t from-gray-100 to-transparent"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (0,clsx_m/* default */.Z)("absolute bottom-0 left-0 right-0 h-10 w-full bg-gradient-to-t from-white to-transparent transition duration-200 ease-in-out", isHovering === false && "opacity-0", isHovering === true && "opacity-100")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute inset-0 z-0 transform bg-white rounded-lg shadow-xl transition-cpu lg:rounded-xl xl:rounded-2xl",
                        style: {
                            opacity: isHovering ? "1" : "0",
                            transition: "transform 0.31s ease-in-out,opacity .17s ease-in-out",
                            transform: isHovering ? "scale(1)" : "scale(.92)"
                        }
                    })
                ]
            });
        }
    });
};

;// CONCATENATED MODULE: ./src/domain/Blog/Posts.js







var defaultProps = {
    posts: [],
    categories: [],
    currentCategory: null
};
var propTypes = {
    posts: prop_types_default().arrayOf((prop_types_default()).object),
    categories: prop_types_default().arrayOf((prop_types_default()).object),
    currentCategory: (prop_types_default()).string
};
function Posts(param) {
    var posts = param.posts, categories = param.categories, currentCategory = param.currentCategory;
    var hasCategories = categories.length !== 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-gray-100",
        children: [
            hasCategories && /*#__PURE__*/ (0,jsx_runtime.jsx)(Categories/* default */.Z, {
                categories: categories,
                active: currentCategory
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                className: "relative z-10 py-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid grid-cols-1 lg:grid-cols-12 lg:gap-8",
                    children: posts.map(function(_param, index) /*#__PURE__*/ {
                        var id = _param.id, post = (0,_object_without_properties/* default */.Z)(_param, [
                            "id"
                        ]);
                        return (0,jsx_runtime.jsx)("div", {
                            className: "flex lg:col-span-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostListing, (0,_object_spread/* default */.Z)({}, post))
                        }, "".concat(id, "-").concat(index));
                    })
                })
            })
        ]
    });
};
Posts.defaultProps = defaultProps;
Posts.propTypes = propTypes;


/***/ }),

/***/ 55733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Category; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _domain_Blog_Posts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82283);



var defaultProps = {
    posts: [],
    categories: []
};
var propTypes = {
    posts: prop_types__WEBPACK_IMPORTED_MODULE_2___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_2___default().object)),
    categories: prop_types__WEBPACK_IMPORTED_MODULE_2___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_2___default().object)),
    currentCategory: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired)
};
var __N_SSG = true;
function Category(param) {
    var posts = param.posts, categories = param.categories, currentCategory = param.currentCategory;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_domain_Blog_Posts__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        posts: posts,
        categories: categories,
        currentCategory: currentCategory
    });
};
Category.defaultProps = defaultProps;
Category.propTypes = propTypes;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(65506); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);